// extracted by mini-css-extract-plugin
export var border = "_f-7";
export var brand = "_f-s";
export var button = "_f-k";
export var center = "_f-9";
export var centered = "_f-5";
export var closeButton = "_f-b";
export var disabledWrapper = "_f-l";
export var error = "_f-o";
export var extraLarge = "_f-4";
export var extraSmall = "_f-1";
export var fill = "_f-h";
export var footer = "_f-g";
export var footerAction = "_f-i";
export var footerButtons = "_f-j";
export var header = "_f-6";
export var headerWithClose = "_f-c";
export var icon = "_f-n";
export var info = "_f-r";
export var inline = "_f-8";
export var large = "_f-3";
export var main = "_f-d";
export var modal = "_f-0";
export var neutral = "_f-t";
export var noPadding = "_f-f";
export var none = "_f-u";
export var scrollable = "_f-e";
export var small = "_f-2";
export var success = "_f-q";
export var tight = "_f-m";
export var titleIcon = "_f-a";
export var warn = "_f-p";